import * as React from 'react';
import { ETargetPage } from '../types';
export var initialValue = {
  isDesktop: true,
  targetPage: ETargetPage.valuation
};
export var widgetContext = /*#__PURE__*/React.createContext(initialValue);
var Provider = widgetContext.Provider;
export { Provider };